module.exports = __webpack_public_path__ + "img/mesaeflor.81aa89eb.webp";